import React from 'react';
import PropTypes from 'prop-types';
import './OnyxChatLayout.css';
import './chat-primitives.css';

/**
 * Three-pane chat chrome (sidebar / main / optional right).
 * Visual styling via `.onyx-chat-*` tokens in mui-overrides — no page-local CSS.
 */
export function OnyxChatLayout({
  sidebar = null,
  children,
  rightRail = null,
  className = '',
}) {
  return (
    <div
      className={['onyx-chat-layout', className].filter(Boolean).join(' ')}
      data-testid="onyx-chat-layout"
    >
      {sidebar ? (
        <aside className="onyx-chat-layout__sidebar" data-testid="onyx-chat-sidebar">
          {sidebar}
        </aside>
      ) : null}
      <main className="onyx-chat-layout__main" data-testid="onyx-chat-main">
        {children}
      </main>
      {rightRail ? (
        <aside className="onyx-chat-layout__rail" data-testid="onyx-chat-rail">
          {rightRail}
        </aside>
      ) : null}
    </div>
  );
}

OnyxChatLayout.propTypes = {
  sidebar: PropTypes.node,
  children: PropTypes.node,
  rightRail: PropTypes.node,
  className: PropTypes.string,
};
